import { PhotoTipResp } from 'types/api/response/photo-tip-resp'

import { api } from './api'

export const getPhotoTip = (id: number) => api.get<PhotoTipResp>(`/photo_tips/${id}`)
